import React from 'react';
import { ShieldIcon, ZapIcon, BrainIcon } from 'lucide-react';
export function Promise() {
  return <section id="promesa" className="w-full bg-[#0f0f0f] py-20 px-4 sm:px-6 lg:px-8" data-id="element-292">
      <div className="max-w-7xl mx-auto" data-id="element-293">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-294">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-295">
            No vendemos solo clases.
            <br className="hidden sm:block" data-id="element-296" />
            <span className="text-[#C9A84C]" data-id="element-297"> Creamos transformación.</span>
          </h2>
          <div className="section-divider mt-4" data-id="element-298" />
        </div>

        {/* Body text */}
        <p className="font-body text-gray-400 text-base sm:text-lg text-center max-w-2xl mx-auto mt-8 mb-16 leading-relaxed" data-id="element-299">
          En Kerchak Fighters Team entrenas con un método que combina{' '}
          <strong className="text-white" data-id="element-300">
            técnica, condición física y progresión
          </strong>
          . Sales del entrenamiento sudado, sí… pero sobre todo sales con
          sensación de <strong className="text-[#C9A84C]" data-id="element-301">avance real</strong>.
        </p>

        {/* 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-302">
          {/* Técnica */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-t-2 border-t-[#C9A84C] p-8 text-center" data-id="element-303">
            <div className="w-14 h-14 bg-[#C9A84C]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-304">
              <ShieldIcon size={28} className="text-[#C9A84C]" data-id="element-305" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-2xl tracking-widest mb-3" data-id="element-306">
              Técnica
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-307">
              Guardia, desplazamientos, combinaciones, defensa
            </p>
          </div>

          {/* Físico */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-t-2 border-t-[#C9A84C] p-8 text-center" data-id="element-308">
            <div className="w-14 h-14 bg-[#C9A84C]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-309">
              <ZapIcon size={28} className="text-[#C9A84C]" data-id="element-310" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-2xl tracking-widest mb-3" data-id="element-311">
              Físico
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-312">
              Resistencia, fuerza funcional, potencia, movilidad
            </p>
          </div>

          {/* Mentalidad */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-t-2 border-t-[#C9A84C] p-8 text-center" data-id="element-313">
            <div className="w-14 h-14 bg-[#C9A84C]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-314">
              <BrainIcon size={28} className="text-[#C9A84C]" data-id="element-315" />
            </div>
            <h3 className="font-heading font-bold text-white uppercase text-2xl tracking-widest mb-3" data-id="element-316">
              Mentalidad
            </h3>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-317">
              Foco, disciplina, confianza, comunidad
            </p>
          </div>
        </div>
      </div>
    </section>;
}